import { Trans } from "react-i18next";
import { DateFormatType, formatDate } from "../../../utils/DateFormatter";
import { type BaseNotificationData, type NotificationDefinition } from "../index";
import { NotificationType } from "../NotificationType";

export interface ExpireQuoteNotificationData extends BaseNotificationData {
  subTypeCode: NotificationType.ExpireQuote;
  salesOrg: string;
  account: string;
  displayAccount: string;
  quoteNumber: string;
  expirationDate: number;
  endCustomerNumber?: string;
}

export const ExpireQuoteNotificationDefinition: NotificationDefinition<ExpireQuoteNotificationData> = {
  type: NotificationType.ExpireQuote,
  renderTitle: (data) => {
    return (
      <Trans i18nKey={"notifications.item.title.quoteExpire"}>
        Quote <span>{{ quoteNumber: data.quoteNumber }}</span> is about to expire
      </Trans>
    );
  },
  renderTitleGA: (data) => {
    return `Quote ${data.quoteNumber} is about to expire`;
  },
  renderContents: (data, { markAsRead }) => {
    const { displayAccount: accountNumber, endCustomerNumber, quoteNumber } = data;
    const detailsUrl = getQuoteDetailsUrl(data);
    return (
      <>
        {!!data.endCustomerNumber && (
          <Trans i18nKey={"notifications.item.text.endCustomer.quoteExpire"}>
            Account <span>{{ accountNumber }}</span> / End Customer <span>{{ endCustomerNumber }}</span>: Quote{" "}
            <a href={detailsUrl} onClick={() => markAsRead(data)}>
              {{ quoteNumber }}
            </a>{" "}
            is about to expire on{" "}
            <span>{{ expirationDate: formatDate(new Date(data.expirationDate), DateFormatType.DATE) }}</span>.
          </Trans>
        )}
        {!data.endCustomerNumber && (
          <Trans i18nKey={"notifications.item.text.quoteExpire"}>
            Account <span>{{ accountNumber: data.displayAccount }}</span>: Quote{" "}
            <a href={detailsUrl} onClick={() => markAsRead(data)}>
              {{ quoteNumber: data.quoteNumber }}
            </a>{" "}
            is about to expire on{" "}
            <span>{{ expirationDate: formatDate(new Date(data.expirationDate), DateFormatType.DATE) }}</span>.
          </Trans>
        )}
      </>
    );
  },
};

export function getQuoteDetailsUrl(data: Omit<ExpireQuoteNotificationData, "subTypeCode">) {
  const baseUrl = "/my-account/quotes/detail";

  const urlParams = new URLSearchParams();
  urlParams.append("id", data.quoteNumber);
  if (data.account) {
    urlParams.append("account", data.account);
  }
  if (data.salesOrg) {
    urlParams.append("salesOrg", data.salesOrg);
  }
  return baseUrl + "?" + urlParams.toString();
}
